import { getService } from 'react-in-angularjs';
import { loggedInUserDataStore } from '../../../stores/loggedInUserDataStore';

export const initUserInfo = async () => {
  const InitUtil = getService('InitUtil');

  await InitUtil.initGeneralAppLogic();
  loggedInUserDataStore.setupUserStore();
};
